import React from 'react';
import { ApIcon } from '@alixpartners/ui-components';

import {
	Wrapper,
	Header,
	HeaderLabel,
	Content,
	IconWrapper,
	List,
	ListItem,
} from './ErrorList.styles';

export class ErrorList extends React.Component {
	state = {
		isCollapsed: false,
	};

	toggle = () => {
		this.setState({ isCollapsed: !this.state.isCollapsed });
	};

	render() {
		const { isCollapsed } = this.state;
		const { errors } = this.props;

		return (
			<Wrapper>
				<Header onClick={this.toggle}>
					<ApIcon iconName="outline_error" iconColor="white" />
					<HeaderLabel>
						{errors.length} issue{errors.length > 1 && 's'} found, please update
						your file and upload again
					</HeaderLabel>
					<IconWrapper isCollapsed={isCollapsed} onClick={this.toggle}>
						<ApIcon iconName="baseline_keyboard_arrow_down" iconColor="white" />
					</IconWrapper>
				</Header>
				{!isCollapsed && (
					<Content>
						<List>
							{errors.map((item, index) => (
								<ListItem key={index}>{item}</ListItem>
							))}
						</List>
					</Content>
				)}
			</Wrapper>
		);
	}
}

export default ErrorList;
